"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Introspector = exports.IntrospectorTypes = void 0;
var IntrospectorTypes;
(function (IntrospectorTypes) {
    IntrospectorTypes[IntrospectorTypes["Enum"] = 0] = "Enum";
    IntrospectorTypes[IntrospectorTypes["Mixin"] = 1] = "Mixin";
    IntrospectorTypes[IntrospectorTypes["Data"] = 2] = "Data";
    IntrospectorTypes[IntrospectorTypes["Adt"] = 3] = "Adt";
    IntrospectorTypes[IntrospectorTypes["Id"] = 4] = "Id";
    IntrospectorTypes[IntrospectorTypes["Service"] = 5] = "Service";
    IntrospectorTypes[IntrospectorTypes["Method"] = 6] = "Method";
    IntrospectorTypes[IntrospectorTypes["List"] = 7] = "List";
    IntrospectorTypes[IntrospectorTypes["Map"] = 8] = "Map";
    IntrospectorTypes[IntrospectorTypes["Opt"] = 9] = "Opt";
    IntrospectorTypes[IntrospectorTypes["Set"] = 10] = "Set";
    IntrospectorTypes[IntrospectorTypes["Str"] = 11] = "Str";
    IntrospectorTypes[IntrospectorTypes["Bool"] = 12] = "Bool";
    IntrospectorTypes[IntrospectorTypes["I08"] = 13] = "I08";
    IntrospectorTypes[IntrospectorTypes["I16"] = 14] = "I16";
    IntrospectorTypes[IntrospectorTypes["I32"] = 15] = "I32";
    IntrospectorTypes[IntrospectorTypes["I64"] = 16] = "I64";
    IntrospectorTypes[IntrospectorTypes["U08"] = 17] = "U08";
    IntrospectorTypes[IntrospectorTypes["U16"] = 18] = "U16";
    IntrospectorTypes[IntrospectorTypes["U32"] = 19] = "U32";
    IntrospectorTypes[IntrospectorTypes["U64"] = 20] = "U64";
    IntrospectorTypes[IntrospectorTypes["F32"] = 21] = "F32";
    IntrospectorTypes[IntrospectorTypes["F64"] = 22] = "F64";
    IntrospectorTypes[IntrospectorTypes["Uid"] = 23] = "Uid";
    IntrospectorTypes[IntrospectorTypes["Tsz"] = 24] = "Tsz";
    IntrospectorTypes[IntrospectorTypes["Tsl"] = 25] = "Tsl";
    IntrospectorTypes[IntrospectorTypes["Tsu"] = 26] = "Tsu";
    IntrospectorTypes[IntrospectorTypes["Time"] = 27] = "Time";
    IntrospectorTypes[IntrospectorTypes["Date"] = 28] = "Date";
})(IntrospectorTypes = exports.IntrospectorTypes || (exports.IntrospectorTypes = {}));
var Introspector = (function () {
    function Introspector() {
    }
    Introspector.register = function (fullClassName, intro) {
        switch (intro.type) {
            case IntrospectorTypes.Adt:
                {
                    if (!Array.isArray(intro.options)) {
                        throw new Error("Registering an Adt requires a list of options.");
                    }
                }
                break;
            case IntrospectorTypes.Id:
            case IntrospectorTypes.Mixin:
            case IntrospectorTypes.Data:
                {
                    if (!Array.isArray(intro.fields)) {
                        throw new Error("Registering a Data / Mixin / Id requires a list of options.");
                    }
                    if (typeof intro.ctor !== 'function') {
                        throw new Error("Registering a Data / Mixin / Id requires a valid ctor to be present.");
                    }
                }
                break;
            case IntrospectorTypes.Enum:
                {
                    if (!Array.isArray(intro.options)) {
                        throw new Error("Registering an Enum requires a list of options.");
                    }
                }
                break;
            case IntrospectorTypes.Service:
                {
                }
                break;
            default: {
                throw new Error("Trying to register an unsupported type for introspection: " + intro);
            }
        }
        Introspector.knownTypesMap[fullClassName] = intro;
        Introspector.knownTypesList.push(intro);
    };
    Introspector.find = function (fullClassName) {
        return Introspector.knownTypesMap[fullClassName];
    };
    Introspector.all = function () {
        return Introspector.knownTypesList;
    };
    Introspector.knownTypesMap = {};
    Introspector.knownTypesList = [];
    return Introspector;
}());
exports.Introspector = Introspector;
//# sourceMappingURL=introspector.js.map